import { keyframes } from "goober";

const slideIn = keyframes`
  from {
    transform: translateX(16px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const sidePanelStyles = `
  box-shadow: var(--elevation-high);
  animation: ${slideIn} var(--motion-base) var(--ease-out);
`;
